import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const RockyMountainMap = ({ onStateClick }) => {
	const [selectedState, setSelectedState] = useState(null);
	const [isVisible, setIsVisible] = useState(true);

	const handleStateClick = (area) => {
		setSelectedState(area);
		setIsVisible(false);
		setTimeout(() => {
			onStateClick(area);
		}, 500);
		console.log('State Clicked: %s', area);
	};

	return (
		<svg
			id='rocky-mountain-region'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 2400 2400'
			className={`map ${!isVisible ? 'hidden' : ''}`}>
			<polygon
				id='NV'
				points='600.75 2349.75 615.75 2313.75 615.75 2198.75 632.75 2177.75 654.24 2177.75 680.75 2201.75 695.75 2201.75 710.75 2181.75 722.75 2142.75 728.75 2090.75 734.75 2051.75 878.75 1248.75 530.75 1182.75 179.75 1104.75 68.75 1577.75 600.75 2349.75'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='NV'
				className={`polygon ${selectedState === 'NV' ? 'selected' : ''}`}
				onClick={() => handleStateClick('NV')}
			/>
			<polygon
				id='UT'
				points='1371.75 2152.75 1447.21 1502.58 1209.75 1467.75 1232.75 1305.75 878.75 1248.75 734.75 2051.75 916.75 2083.75 1256.75 2136.75 1371.75 2152.75'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='UT'
				className={`polygon ${selectedState === 'UT' ? 'selected' : ''}`}
				onClick={() => handleStateClick('UT')}
			/>
			<polygon
				id='CO'
				points='1371.75 2152.75 1647.75 2183.75 1931.75 2210.75 2139.75 2224.75 2266.75 2234.75 2297.75 1575.75 2054.75 1564.75 1447.21 1502.58 1371.75 2152.75'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='CO'
				className={`polygon ${selectedState === 'CO' ? 'selected' : ''}`}
				onClick={() => handleStateClick('CO')}
			/>
			<polygon
				id='WY'
				points='2054.75 1564.75 2101.27 912.46 1774.75 885.75 1494.75 853.75 1301.75 824.75 1232.75 1305.75 1209.75 1467.75 1447.21 1502.58 2054.75 1564.75'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='WY'
				className={`polygon ${selectedState === 'WY' ? 'selected' : ''}`}
				onClick={() => handleStateClick('WY')}
			/>
			<polygon
				id='MT'
				points='2101.27 912.46 2146.75 274.75 1718.75 233.75 1335.75 184.75 1074.75 139.75 862.75 98.75 849.75 178.75 831.75 257.75 862.75 328.75 856.75 349.75 910.75 425.75 944.75 486.75 975.75 500.75 975.75 517.75 935.75 625.75 935.75 667.75 946.75 678.75 969.75 674.75 994.75 663.75 1004.75 671.75 1013.75 707.75 1026.75 791.75 1036.75 812.75 1055.75 820.75 1063.75 835.75 1063.75 865.75 1078.75 886.75 1092.75 883.75 1101.75 876.75 1189.75 876.75 1224.75 885.75 1239.75 885.75 1255.75 861.75 1264.75 865.75 1278.75 890.75 1290.96 899.94 1301.75 824.75 1494.75 853.75 1774.75 885.75 2101.27 912.46'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='MT'
				className={`polygon ${selectedState === 'MT' ? 'selected' : ''}`}
				onClick={() => handleStateClick('MT')}
			/>
			<polygon
				id='ID'
				points='862.75 98.75 756.75 78.75 691.75 401.75 675.75 489.75 675.75 556.75 699.75 594.75 709.75 615.75 703.75 636.75 672.75 679.75 645.75 723.75 587.75 785.75 587.75 816.21 603.75 827.75 611.75 836.75 604.75 867.75 587.75 907.99 530.75 1182.75 878.75 1248.75 1232.75 1305.75 1290.96 899.94 1278.75 890.75 1264.75 865.75 1255.75 861.75 1239.75 885.75 1224.75 885.75 1189.75 876.75 1101.75 876.75 1092.75 883.75 1078.75 886.75 1063.75 865.75 1063.75 835.75 1055.75 820.75 1036.75 812.75 1026.75 791.75 1013.75 707.75 1004.75 671.75 994.75 663.75 969.75 674.75 946.75 678.75 935.75 667.75 935.75 625.75 975.75 517.75 975.75 500.75 944.75 486.75 910.75 425.75 856.75 349.75 862.75 328.75 831.75 257.75 849.75 178.75 862.75 98.75'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='ID'
				className={`polygon ${selectedState === 'ID' ? 'selected' : ''}`}
				onClick={() => handleStateClick('ID')}
			/>
			<rect x='1721.75' y='1704.75' width='158' height='38' fill='none' className='shape' />
			<path
				d='M1768.18,1712.59c1.86-.32,3.91-.49,6.03-.49,4.05,0,7.13,1.15,8.93,3.23,1.31,1.35,2.27,3.52,2.28,6.58,0,4.39-1.75,8.74-4.87,11.4-2.81,2.36-6.34,3.38-11,3.38-2.12,0-4.31-.12-5.89-.3l4.52-23.79ZM1767.09,1734.05c1.09.14,2.23.17,3.13.17,3.85,0,6.66-1.13,8.68-3.22,2.18-2.23,3.31-5.54,3.31-8.95,0-4.29-2.1-7.5-8.15-7.5-1.08,0-2.44.07-3.31.25l-3.66,19.25Z'
				className='shape'
			/>
			<path
				d='M1802.64,1735.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1799.34,1721.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1809.28,1736.53l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1835.04,1719.12l1.5,9.91c.26,1.98.49,3.32.56,4.28h.1c.38-.92.85-2.07,1.86-4.05l5.31-10.13h3.27l-9.69,17.41h-2.94l-3.01-17.41h3.04Z'
				className='shape'
			/>
			<path
				d='M1862.69,1735.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1859.39,1721.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1869.32,1736.53l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<polygon
				points='1912.79 1733.83 1913.16 1748.75 1928.85 1748.75 1913.39 1757.97 1913.76 1772.9 1903.83 1763.67 1888.37 1772.9 1897.7 1757.97 1887.77 1748.75 1903.46 1748.75 1912.79 1733.83'
				className='shape'
			/>
			<rect x='1713.75' y='1489.75' width='218' height='38' fill='none' className='shape' />
			<path
				d='M1787.21,1520.75c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.99-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M1793.2,1521.53l4.86-25.56h2.98l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<path
				d='M1827.86,1520.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1824.56,1506.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1838.4,1504.12l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.57c.75-.26,2.01-.75,3.19-1.67,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<path
				d='M1865.62,1520.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1862.32,1506.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1872.26,1521.53l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1894.36,1521.53l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1929.02,1520.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1925.72,1506.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='1966.45 1515.83 1966.82 1530.75 1982.51 1530.75 1967.05 1539.97 1967.42 1554.9 1957.49 1545.67 1942.03 1554.9 1951.36 1539.97 1941.43 1530.75 1957.12 1530.75 1966.45 1515.83'
				className='shape'
			/>
			<rect x='1245.9' y='571.75' width='156.85' height='38' fill='none' className='shape' />
			<path
				d='M1254.62,579.27l-1.96,10.23h11.16l1.95-10.23h2.99l-4.62,24.26h-2.99l2.15-11.4h-11.16l-2.15,11.4h-2.98l4.61-24.26h2.98Z'
				className='shape'
			/>
			<path
				d='M1284.92,602.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1281.62,588.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path d='M1291.56,603.53l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M1315.23,602.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1311.93,588.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1321.87,603.53l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1355.51,603.53c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1357.45,588.35c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<polygon
				points='1227.14 549.83 1227.51 564.75 1243.2 564.75 1227.74 573.97 1228.11 588.9 1218.18 579.67 1202.72 588.9 1212.05 573.97 1202.12 564.75 1217.81 564.75 1227.14 549.83'
				className='shape'
			/>
			<rect x='668.9' y='961.75' width='295' height='76' fill='none' className='shape' />
			<path
				d='M674.56,988.61c1.48-.3,3.23-.5,5.2-.5,2.5,0,4.31.5,5.6,1.66,1.12.91,1.74,2.2,1.74,3.78,0,3.07-2.47,5.34-5.22,6.05v.1c2.19.64,4,2.46,3.98,5.38,0,2.48-1.32,4.43-2.9,5.62-1.93,1.44-4.6,1.99-7.85,1.99-2.08,0-3.89-.13-5.03-.34l4.49-23.74ZM673.41,1010.12c.76.12,1.64.16,2.45.16,3.53.02,6.85-1.46,6.85-5.34,0-2.85-2.4-4.1-5.12-4.1h-2.43l-1.75,9.28ZM675.63,998.56h2.22c3.48,0,6.16-1.8,6.16-4.75,0-2.34-1.76-3.33-4.4-3.33-1.1,0-2.01.08-2.48.22l-1.5,7.86Z'
				className='shape'
			/>
			<path
				d='M708.29,1001.97c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM694.91,1005.66c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M713.26,1012.53l3.33-17.41h2.98l-3.33,17.41h-2.98ZM717.14,990.26c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M724.53,1009.51c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M753.25,1011.53c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM749.94,997.05c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='665.14 930.83 665.51 945.75 681.2 945.75 665.74 954.97 666.11 969.9 656.18 960.67 640.72 969.9 650.05 954.97 640.12 945.75 655.81 945.75 665.14 930.83'
				className='shape'
			/>
			<rect x='768.9' y='1435.75' width='305.85' height='35' fill='none' className='shape' />
			<path
				d='M847.76,1462.28c1.32.89,3.14,1.55,5.16,1.55,2.73,0,5.24-1.63,5.24-4.55,0-1.8-1.02-3.15-3.55-4.54-3.1-1.68-4.83-3.62-4.83-6.22,0-4.34,3.73-7.12,8.19-7.12,2.37,0,4.14.69,4.97,1.26l-1.06,2.44c-.76-.46-2.28-1.16-4.21-1.14-3,0-4.8,1.97-4.81,3.96,0,1.97,1.23,3.09,3.77,4.5,2.99,1.6,4.63,3.51,4.63,6.49,0,4.2-3.29,7.5-8.75,7.5-2.43,0-4.82-.79-5.84-1.69l1.08-2.44Z'
				className='shape'
			/>
			<path
				d='M878.81,1466.03c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM880.74,1450.85c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path d='M888.94,1466.03l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M907.85,1443.94l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M928.35,1441.77h2.99l-4.14,21.67h9.79l-.5,2.59h-12.75l4.61-24.26Z'
				className='shape'
			/>
			<path
				d='M953.86,1466.03c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM955.8,1450.85c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M964,1466.03l4.86-25.56h2.97l-3.06,16.02h.07c.53-.61,1.17-1.27,1.63-1.75l6.13-6.12h3.69l-7.6,7.15,5.2,10.26h-3.29l-4.19-8.59-2.2,1.96-1.25,6.63h-2.96Z'
				className='shape'
			/>
			<path
				d='M995.34,1465.03c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM992.04,1450.55c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1028.28,1465.25c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.99-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M1034.23,1466.03l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1038.1,1443.76c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M1053.14,1443.94l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M1063.7,1448.62l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.57c.75-.26,2.01-.75,3.19-1.67,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<polygon
				points='1106.14 1469.83 1106.51 1484.75 1122.2 1484.75 1106.74 1493.97 1107.11 1508.9 1097.18 1499.67 1081.72 1508.9 1091.05 1493.97 1081.12 1484.75 1096.81 1484.75 1106.14 1469.83'
				className='shape'
			/>
			<rect x='124.9' y='1532.75' width='194.85' height='38' fill='none' className='shape' />
			<path
				d='M142.79,1563.75c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.99-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M160.03,1564.53c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM161.97,1549.35c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M170.23,1564.53l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M184.71,1561.51c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M217.57,1553.97c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM204.19,1557.66c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M222.54,1564.53l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M270.95,1563.75c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.99-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M276.9,1564.53l3.33-17.41h2.98l-3.33,17.41h-2.98ZM280.78,1542.26c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M295.81,1542.44l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M306.37,1547.12l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.57c.75-.26,2.01-.75,3.19-1.67,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<polygon
				points='111.14 1499.83 111.51 1514.75 127.2 1514.75 111.74 1523.97 112.11 1538.9 102.18 1529.67 86.72 1538.9 96.05 1523.97 86.12 1514.75 101.81 1514.75 111.14 1499.83'
				className='shape'
			/>
			<rect
				x='1332.76'
				y='409.76'
				width='310.99'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1375.66,461.96l3.48-26.21c.63-4.63,1.71-11.74,2.63-16.42h-.23c-2.24,4.9-4.95,10.67-7.59,15.64l-14.42,26.69h-4.57l-3.59-26.14c-.74-5.57-1.23-11.21-1.56-16.18h-.16c-1.02,4.48-2.54,11.81-3.7,16.44l-6.6,26.2h-5.62l12.57-48.53h7.62l3.84,27.83c.48,4.12,1.04,8.56,1.17,12.17h.22c1.47-3.61,3.55-7.96,5.65-12l15.02-28h7.81l-6.16,48.53h-5.81Z'
				className='shape'
			/>
			<path
				d='M1430.14,440.83c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1403.36,448.22c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1440.07,461.96l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.14h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M1499.87,417.78l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.29,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.26-4.01.76-6.53l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M1535.59,461.96c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.92-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM1539.47,431.59c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M1555.99,461.96l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.14h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M1623.29,461.96c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.92-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM1627.16,431.59c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='1511.67'
				y='1141.6'
				width='321.08'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1521.06,1193.79l-2.38-48.53h6l1.03,29.09c.18,6.28.06,9.59,0,12.64h.17c1.13-3.17,2.31-6.32,4.99-12.3l13.44-29.43h6.39l1,27.94c.22,6.29.22,10.5.11,13.7h.16c1.43-4.17,2.88-8.07,4.74-12.49l13.08-29.14h6.26l-22.52,48.53h-6.32l-1.24-27.61c-.26-5.64-.2-8.4.11-13.96h-.18c-1.62,4.65-2.91,8.36-4.9,12.77l-13.54,28.8h-6.4Z'
				className='shape'
			/>
			<path
				d='M1586.83,1158.97l3.45,18.73c.77,4.01,1.23,6.58,1.57,9.18h.18c.92-2.23,1.94-4.67,3.69-8.53l8.92-19.38h6.34l-13.08,26.47c-3.74,7.55-7.27,13.66-12,18.32-3.89,3.92-8.15,5.58-10.13,6.01l-1.46-5.13c1.5-.52,4.03-1.5,6.38-3.35,2.36-1.82,4.87-4.62,6.73-8.04.31-.57.28-.97.17-1.58l-6.98-32.7h6.21Z'
				className='shape'
			/>
			<path
				d='M1649.59,1172.66c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1622.81,1180.05c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1659.51,1193.79l4.62-24.69c.76-3.87,1.23-7.25,1.61-10.14h5.27l-.92,6.53h.17c3.26-4.86,7.64-7.33,12.27-7.33,5.3,0,7.88,3.37,8.13,7.77,3.12-5.04,7.55-7.69,12.79-7.77,4.03,0,8.46,2.57,8.46,9.13,0,1.61-.22,3.95-.57,5.92l-3.89,20.56h-5.83l3.76-20.06c.25-1.35.51-3.1.51-4.55,0-3.69-1.4-6.05-5.25-6.05-4.36,0-9.5,5.01-10.94,12.81l-3.32,17.85h-5.81l3.89-20.44c.29-1.56.47-2.89.47-4.25,0-2.93-.82-5.97-5.23-5.97s-9.79,5.76-11.12,13.15l-3.22,17.51h-5.83Z'
				className='shape'
			/>
			<path
				d='M1723.45,1193.79l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1731.2,1149.25c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1745.69,1193.79l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.14h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M1790.21,1201.71c2.11,1.34,5.58,2.28,9.24,2.28,5.86,0,10.45-2.97,12.52-12.4l1.15-5.21h-.18c-3.05,4.99-7.29,7.4-12.11,7.4-7,0-10.6-5.89-10.61-12.06-.02-11.86,8.63-23.53,22.11-23.53,4.04,0,8.44,1.13,11.17,2.43l-5.34,28.78c-1.4,7.38-3.4,12.47-7.02,15.59-3.48,3.02-8.19,3.86-12.16,3.86-4.24,0-8.26-.98-10.44-2.46l1.67-4.67ZM1816.97,1164.15c-1.1-.55-3.26-1.19-5.76-1.19-8.71,0-14.71,9.11-14.75,17.71-.02,3.86,1.37,8.35,6.67,8.35s10.33-6.47,11.62-13.27l2.22-11.6Z'
				className='shape'
			/>
			<rect
				x='1607.67'
				y='1892.94'
				width='310.99'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1643.46,1943.57c-2.74,1.23-7.14,2.33-12.59,2.33-12.22,0-19.7-7.77-19.7-20.15,0-9.14,3.7-17.85,10.36-23.39,5.02-4.24,11.2-6.51,18.29-6.51,5.4,0,9.27,1.35,10.52,2.33l-1.93,4.82c-1.8-1.09-5.22-2-9.54-2-5.08,0-10.16,1.97-13.9,5.44-4.56,4.27-7.44,11.11-7.44,18.48,0,8.67,3.99,15.84,14.77,15.84,3.66,0,7.67-.73,10.37-2.08l.79,4.88Z'
				className='shape'
			/>
			<path
				d='M1688.35,1924c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1661.57,1931.39c0,5.66,3.14,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path d='M1698.29,1945.13l9.75-51.12h5.97l-9.76,51.12h-5.96Z' className='shape' />
			<path
				d='M1753.94,1924c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1727.16,1931.39c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1763.86,1945.13l4.26-22.43c.85-4.54,1.38-9.16,1.77-12.39h5.26c-.28,2.42-.57,4.85-.97,7.57h.21c2.28-4.77,6-8.36,10.67-8.36.55,0,1.24.04,1.71.13l-1.16,5.89c-.42-.08-.95-.12-1.62-.12-5.17,0-9.77,6.27-11.28,14.35l-2.88,15.36h-5.96Z'
				className='shape'
			/>
			<path
				d='M1814.53,1945.13c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM1818.4,1914.77c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.03,3.89,1.35,7.68,5.95,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M1871.82,1894.01l-7.64,40.08c-.67,3.61-1.26,7.67-1.47,11.04h-5.47l.93-6.89h-.14c-3.18,4.94-7.56,7.68-12.56,7.68-6.71,0-10.4-5.52-10.4-12.67,0-12.38,9.2-23.73,21.54-23.73,2.19,0,4.64.47,6.15,1.19l3.12-16.7h5.94ZM1861.8,1915.77c-1.21-.82-3.2-1.48-5.7-1.48-8.36,0-14.85,8.9-14.85,18.15,0,4.22,1.44,8.59,6.57,8.59,4.58,0,10.15-5.25,11.65-13.08l2.33-12.18Z'
				className='shape'
			/>
			<path
				d='M1911.76,1924c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1884.98,1931.39c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<rect
				x='1033.67'
				y='1685.94'
				width='176.08'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1051.04,1689.6l-5.46,28.76c-.4,2.01-.6,4.1-.6,6.08.02,6.23,3.62,9.38,9.02,9.38,6.63,0,11.46-4.48,13.54-15.39l5.52-28.84h5.97l-5.55,29.02c-2.79,14.51-9.99,20.31-20.31,20.31-8.01,0-14.17-4.35-14.17-14.33,0-2.07.23-4.44.66-6.67l5.41-28.32h5.97Z'
				className='shape'
			/>
			<path
				d='M1101.99,1693.95l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.29,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.26-4.01.76-6.53l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M1137.71,1738.14c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.92-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM1141.59,1707.77c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M1157.97,1738.14l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<rect
				x='808.67'
				y='1033.94'
				width='201.08'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path d='M826.04,1037.6l-9.24,48.53h-5.96l9.23-48.53h5.97Z' className='shape' />
			<path
				d='M870.29,1035.01l-7.64,40.08c-.67,3.61-1.26,7.67-1.47,11.04h-5.47l.93-6.89h-.14c-3.18,4.94-7.56,7.68-12.56,7.68-6.71,0-10.4-5.52-10.4-12.67,0-12.38,9.2-23.73,21.54-23.73,2.19,0,4.64.47,6.15,1.19l3.12-16.7h5.94ZM860.26,1056.77c-1.21-.82-3.2-1.48-5.7-1.48-8.36,0-14.85,8.9-14.85,18.15,0,4.22,1.44,8.59,6.57,8.59,4.58,0,10.15-5.25,11.65-13.08l2.33-12.18Z'
				className='shape'
			/>
			<path
				d='M899.9,1086.14c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM903.77,1055.77c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.03,3.89,1.35,7.68,5.95,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M920.15,1086.14l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<path
				d='M997.78,1065c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM971,1072.39c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.21,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<rect
				x='285.67'
				y='1408.94'
				width='260.08'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M287.91,1461.14l9.23-48.53h6.54l11.12,27.48c2.15,5.52,3.24,9.36,4.26,13.53l.16-.08c.26-4.36.77-8.39,2.03-15.19l4.9-25.75h5.65l-9.23,48.53h-5.9l-11.06-27.43c-2.37-6-3.45-9.41-4.5-14l-.21.08c-.53,4.54-1.31,9.39-2.55,15.99l-4.79,25.37h-5.63Z'
				className='shape'
			/>
			<path
				d='M364.09,1459.14c-2.63,1.48-6.84,2.75-11.51,2.75-9.25,0-13.25-6.3-13.25-14.01,0-10.49,7.79-22.36,19-22.36,6.63,0,10.22,3.95,10.23,8.93,0,9.15-10.31,11.55-23.18,11.31-.29,1.51-.09,4.76.7,6.63,1.4,3.14,4.17,4.68,7.75,4.68,4.14,0,7.25-1.23,9.38-2.39l.88,4.45ZM357.49,1430.17c-5.69,0-9.98,5.55-11.44,11,9.38.11,16.73-1.14,16.73-6.57,0-2.86-2.18-4.44-5.3-4.44Z'
				className='shape'
			/>
			<path
				d='M385.32,1426.31l3,19.83c.53,3.96.98,6.65,1.12,8.55h.2c.76-1.84,1.69-4.14,3.71-8.11l10.63-20.27h6.55l-19.38,34.82h-5.88l-6.02-34.82h6.08Z'
				className='shape'
			/>
			<path
				d='M437.95,1461.14c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM441.83,1430.77c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M495.24,1410.01l-7.64,40.08c-.67,3.61-1.26,7.67-1.47,11.04h-5.47l.93-6.89h-.14c-3.18,4.94-7.56,7.68-12.56,7.68-6.71,0-10.4-5.52-10.4-12.67,0-12.38,9.2-23.73,21.54-23.73,2.19,0,4.64.47,6.15,1.19l3.12-16.7h5.94ZM485.22,1431.77c-1.21-.82-3.2-1.48-5.7-1.48-8.36,0-14.85,8.9-14.85,18.15,0,4.22,1.44,8.59,6.57,8.59,4.58,0,10.15-5.25,11.65-13.08l2.33-12.18Z'
				className='shape'
			/>
			<path
				d='M524.86,1461.14c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM528.73,1430.77c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
		</svg>
	);
};

RockyMountainMap.propTypes = {
	onStateClick: PropTypes.func.isRequired,
	selectedState: PropTypes.string,
};

export default RockyMountainMap;
